import gno from 'assets/img/icons/gno.svg'

export const blockchainIcons = {
    gno
}